import { getAsyncState } from '../selectors';
export var getOrdersState = getAsyncState('orders');
